'use client';

import { BrokerId, FrontendLoadLocation } from '@trucksmarter/shared';
import { HovercardAnchor, Hovercard, useHovercardStore } from '@ariakit/react';
import DallasText from '~/app/_ui/Dallas/Text/DallasText';
import LoadTableStopList from './LoadTableStopList';

import styles from './LoadTableStopListHovercardAnchor.module.scss';

interface Props {
  stops: FrontendLoadLocation[];
  brokerId: BrokerId;
  children: React.ReactNode;
}

export default function LoadTableStopListHovercardAnchor({
  stops,
  brokerId,
  children,
}: Props) {
  const hovercardStore = useHovercardStore({
    placement: 'top-start',
    showTimeout: 200,
    hideTimeout: 0,
  });

  return (
    <>
      <HovercardAnchor store={hovercardStore} render={<div />}>
        {children}
      </HovercardAnchor>
      {hovercardStore.useState('open') && (
        <Hovercard
          className={styles.hovercard}
          store={hovercardStore}
          gutter={16}
        >
          <DallasText>Stops</DallasText>
          <LoadTableStopList stops={stops} brokerId={brokerId} />
        </Hovercard>
      )}
    </>
  );
}
